import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={15.742}
    height="6.8mm"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 7356 12010"
    {...props}
  >
    <defs>
      {/* <style>{".fil0{fill:#343230}"}</style> */}
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974582327456">
        <path
          d="M432 5817h6492L5473 375H1883L432 5817zm6737 376H188c-59 0-113-28-149-74s-48-106-32-162L1558 140c22-82 96-140 181-140h3879c84 0 158 58 180 140l1552 5817c15 56 3 116-33 162-35 46-90 74-148 74z"
          className="fil0"
        />
        <path
          d="M376 6193v412c0 208 168 376 375 376h37c207 0 376-168 376-376v-412H376zm412 1163h-37c-414 0-751-337-751-751v-600c0-104 84-188 188-188h1163c104 0 188 84 188 188v600c0 414-337 751-751 751z"
          className="fil0"
        />
        <path
          d="M1539 6193v412c0 208 168 376 376 376h37c207 0 375-168 375-376v-412h-788zm413 1163h-37c-415 0-751-337-751-751v-600c0-104 84-188 187-188h1164c103 0 187 84 187 188v600c0 414-336 751-750 751z"
          className="fil0"
        />
        <path
          d="M2702 6193v412c0 208 169 376 376 376h37c207 0 376-168 376-376v-412h-789zm413 1163h-37c-414 0-751-337-751-751v-600c0-104 84-188 188-188h1163c104 0 188 84 188 188v600c0 414-337 751-751 751z"
          className="fil0"
        />
        <path
          d="M3866 6193v412c0 208 168 376 375 376h38c207 0 375-168 375-376v-412h-788zm413 1163h-38c-414 0-750-337-750-751v-600c0-104 83-188 187-188h1164c104 0 187 84 187 188v600c0 414-337 751-750 751z"
          className="fil0"
        />
        <path
          d="M5029 6193v412c0 208 169 376 376 376h37c207 0 376-168 376-376v-412h-789zm413 1163h-37c-414 0-751-337-751-751v-600c0-104 84-188 188-188h1163c104 0 188 84 188 188v600c0 414-337 751-751 751z"
          className="fil0"
        />
        <path
          d="M6193 6193v412c0 208 168 376 375 376h38c207 0 375-168 375-376v-412h-788zm413 1163h-38c-414 0-750-337-750-751v-600c0-104 83-188 187-188h1164c103 0 187 84 187 188v600c0 414-337 751-750 751zM5618 2217c-30 0-59-6-84-19l-886-443-886 443c-53 26-115 26-168 0l-886-443-885 443c-53 26-115 26-168 0l-433-217c-93-46-131-159-84-252 46-93 159-130 251-84l350 175 886-443c53-26 115-26 167 0l886 443 886-443c53-26 115-26 168 0l886 443 349-175c92-46 205-9 252 84 46 93 8 206-84 252l-434 217c-26 13-55 19-83 19z"
          className="fil0"
        />
        <path
          d="M3678 2993c-29 0-58-7-84-20l-886-443-885 443c-53 26-115 26-168 0l-616-308c-93-46-130-158-84-252 46-92 160-130 252-84l532 267 886-443c53-27 115-27 167 0l886 443 886-443c53-26 115-27 168 0l886 443 532-267c92-46 205-8 251 84 46 94 9 206-84 252l-616 308c-53 26-115 26-167 0l-886-443-886 443c-27 13-55 20-84 20zM6858 5029H498c-104 0-188-84-188-187 0-104 84-188 188-188h6360c104 0 188 84 188 188 0 103-84 187-188 187zM6652 4253H705c-104 0-188-84-188-187 0-104 84-188 188-188h5947c103 0 187 84 187 188 0 103-84 187-187 187zM4066 11234h-775c-105 0-188-84-188-187V7135c0-104 83-187 188-187 103 0 187 83 187 187v3724h401V7135c0-104 83-187 187-187s188 83 188 187v3912c0 103-84 187-188 187z"
          className="fil0"
        />
        <path
          d="M3711 6968h-66c-104 0-188-84-188-187 0-104 84-188 188-188h66c104 0 188 84 188 188 0 103-84 187-188 187zM2121 11635h3115v-401H2121v401zm3302 375H1933c-104 0-188-84-188-188l1-775c0-104 83-188 187-188h3490c104 0 188 84 188 188v775c0 104-84 188-188 188z"
          className="fil0"
        />
        <path
          d="M7169 12010H188c-104 0-188-84-188-188s84-187 188-187h6981c103 0 187 83 187 187s-84 188-187 188zM5423 8519c-103 0-187-84-187-187V7168c0-103 84-187 187-187 104 0 188 84 188 187v1164c0 103-84 187-188 187z"
          className="fil0"
        />
        <path
          d="M5423 8713c-110 0-200 90-200 201 0 110 90 200 200 200 111 0 201-90 201-200 0-111-90-201-201-201zm0 776c-317 0-575-258-575-575s258-576 575-576c318 0 576 259 576 576s-258 575-576 575z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
